/**
 * Kích thước dây của sản phẩm — 6 số đo, mỗi số một đơn vị.
 *
 * Lưu dưới dạng JSON trong một cột text, đúng hình dạng hệ thống cũ ghi ra
 * (length/width/height/innerWidth/diameter/wireDiameter + *Unit). GIỮ NGUYÊN
 * hình dạng đó thay vì tách thành 12 cột: 1400 sản phẩm đã di trú mang đúng
 * JSON này, và chỉ 9 sản phẩm thật sự có số đo — tách cột là 12 cột trống trên
 * mọi bảng để phục vụ 0,6% dữ liệu.
 */

export const WIRE_SIZE_FIELDS = [
  "length", "width", "height", "innerWidth", "diameter", "wireDiameter",
] as const;

export type WireSizeField = (typeof WIRE_SIZE_FIELDS)[number];

/** Đơn vị hệ cũ cho phép (systemSettings.defaultSizeUnit). */
export const SIZE_UNITS = ["mm", "cm", "inch", "L"] as const;

export type WireSize = Record<string, string>;

export function parseWireSize(raw: string | null | undefined): WireSize {
  if (!raw) return {};
  try {
    const o = JSON.parse(raw) as Record<string, unknown>;
    return o && typeof o === "object" ? (o as WireSize) : {};
  } catch {
    // Giá trị cũ không phải JSON (chuỗi tự do) — không vứt đi, đưa vào ô đầu
    // để người dùng còn thấy và sửa được.
    return { length: raw };
  }
}

/**
 * Dựng lại JSON để lưu. Trả về chuỗi rỗng khi KHÔNG có số đo nào — để cột thành
 * NULL thay vì lưu một bộ khung rỗng như 1391 sản phẩm di trú đang mang.
 */
export function serializeWireSize(v: WireSize): string {
  const hasValue = WIRE_SIZE_FIELDS.some((f) => (v[f] ?? "").trim() !== "");
  if (!hasValue) return "";
  const out: WireSize = {};
  for (const f of WIRE_SIZE_FIELDS) {
    const val = (v[f] ?? "").trim();
    out[f] = val;
    // Đơn vị chỉ đi kèm khi ô đó có số: một đơn vị đứng một mình không nói gì.
    out[`${f}Unit`] = val ? (v[`${f}Unit`] || "mm") : "";
  }
  return JSON.stringify(out);
}
